import type { InstallationWindowOption } from 'flows/tvi/components/review/config/providers/types';
/**
 * Installation time window options for TVI providers
 * Single source of truth for all window definitions
 */

export const AttInstallationWindows: InstallationWindowOption[] = [
  {
    id: 'date1InstallationFirstWindow',
    value: '8am to 12pm',
    label: '8am to 12pm',
  },
  {
    id: 'date1InstallationSecondWindow',
    value: '12pm to 5pm',
    label: '12pm to 5pm',
  },
];

export const XfinityInstallationWindows: InstallationWindowOption[] = [
  {
    id: 'xfinityFirstWindow',
    value: '8am to 10am',
    label: '8am to 10am',
  },
  {
    id: 'xfinitySecondWindow',
    value: '10am to 12pm',
    label: '10am to 12pm',
  },
  {
    id: 'xfinityThirdWindow',
    value: '1pm to 3pm',
    label: '1pm to 3pm',
  },
  {
    id: 'xfinityFourthWindow',
    value: '3pm to 5pm',
    label: '3pm to 5pm',
  },
];

export const SpectrumInstallationWindows: InstallationWindowOption[] = [
  {
    id: 'spectrumInstallationFirstWindow',
    value: '8am to 12pm',
    label: '8am to 12pm',
  },
  {
    id: 'spectrumInstallationSecondWindow',
    value: '12pm to 5pm',
    label: '12pm to 5pm',
  },
];

export const CoxInstallationWindows: InstallationWindowOption[] = [
  {
    id: 'coxInstallationFirstWindow',
    value: '8am to 10am',
    label: '8am to 10am',
  },
  {
    id: 'coxInstallationSecondWindow',
    value: '10am to 12pm',
    label: '10am to 12pm',
  },
  {
    id: 'coxInstallationThirdWindow',
    value: '1pm to 3pm',
    label: '1pm to 3pm',
  },
  {
    id: 'coxInstallationFourthWindow',
    value: '3pm to 5pm',
    label: '3pm to 5pm',
  },
];
